import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

export function findPhoneBlacklistActive ({ keywords, limit, offset, order } = {}) {
  const filter = { limit, offset, order }

  if (keywords) {
    filter.where = {
      phoneNumber: { ilike: `%${String(keywords).trim()}%` }
    }
  }

  return apiRequests.get('/v1/phone-blacklist/', {
    params: { filter },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function findActivePhoneBlacklistByPhoneNumber (phoneNumber) {
  const filter = {
    where: { phoneNumber: String(phoneNumber || '').trim() },
    order: 'dateCreated DESC'
  }

  return apiRequests.get('/v1/phone-blacklist/', {
    params: { filter },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data?.length ? result.data[0] : null)
}

export function countPhoneBlacklistActive ({ keywords } = {}) {
  const where = {}

  if (keywords) {
    where.phoneNumber = { ilike: `%${String(keywords).trim()}%` }
  }

  return apiRequests.get('/v1/phone-blacklist/count', {
    params: { where },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function findPhoneBlacklist ({ where, keywords, limit, offset, order } = {}) {
  const filter = { where: where || {}, limit, offset, order }

  if (keywords) {
    filter.where = {
      ...filter.where,
      phoneNumber: { ilike: `%${String(keywords).trim()}%` }
    }
  }

  return apiRequests.get('/v1/raw-phone-blacklist/', {
    params: { filter },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function countPhoneBlacklist ({ where, keywords } = {}) {
  where = where || {}

  if (keywords) {
    where.phoneNumber = { ilike: `%${String(keywords).trim()}%` }
  }

  return apiRequests.get('/v1/raw-phone-blacklist/count', {
    params: { where },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function getPhoneBlacklistById (id) {
  return apiRequests.get('/v1/raw-phone-blacklist/' + id + '/', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function blacklistPhone ({ phoneNumber, threatLevel, note } = {}) {
  return apiRequests.post('/v1/phone-blacklist/', { phoneNumber, threatLevel, note }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function patchPhoneBlacklist ({ id, patch } = {}) {
  return apiRequests.patch('/v1/phone-blacklist/' + id + '/', patch || {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

export function restorePhone ({ phoneNumber, note } = {}) {
  return apiRequests.patch('/v1/phone-blacklist/restore/', { phoneNumber, note }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}
